import { Component } from '@angular/core';

declare var Mmenu: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor() {}

  title = 'HOPITAL_FPPN_CLIENT';
}
